export default function Jejak() {
    return {
        id: null,
        timestamp: null,
        enumStage: null,
        transaksiId: null,
    };
}
